'use client'

import { useEffect, useState } from 'react'
import { CONSENT_CHANGED_EVENT } from 'components/EventHorizonTealium/eventHorizonTealiumBootstrap'
import { isEhConsentTealiumEnabled } from 'utils/consent/ehConsentTealiumEnabled'
import { isEhTrackingAllowed } from 'utils/consent/isEhTrackingAllowed'

function readAllowed() {
  return isEhTrackingAllowed()
}

/**
 * Client hook: false until eh_consent_v1 is valid when EH pilot is enabled; otherwise true.
 */
export function useEhTrackingAllowed() {
  const [allowed, setAllowed] = useState(readAllowed)

  useEffect(() => {
    if (!isEhConsentTealiumEnabled()) {
      setAllowed(true)
      return undefined
    }

    setAllowed(readAllowed())
    const sync = () => setAllowed(readAllowed())
    window.addEventListener(CONSENT_CHANGED_EVENT, sync)
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, sync)
  }, [])

  return allowed
}
